import { Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

import {
  COOKIE_POLICY_EFFECTIVE_DATE_LABEL,
  COOKIE_POLICY_VERSION,
  cookiePolicySections,
} from './cookie-policy-content';
import { LegalDocumentPage } from './legal-document';
import { PRIVACY_POLICY_OWNER_EMAIL } from './privacy-policy-content';

export function CookiePolicyPage() {
  return (
    <LegalDocumentPage
      title="Política de Cookies"
      icon={Cookie}
      asideSummary="Identifica os Rastreadores utilizados pela BelaHora, todos estritamente necessários, e explica como controlá-los no navegador."
      meta={[
        { label: 'Versão', value: COOKIE_POLICY_VERSION },
        {
          label: 'Entrada em vigor',
          value: COOKIE_POLICY_EFFECTIVE_DATE_LABEL,
        },
        { label: 'Contacto', value: PRIVACY_POLICY_OWNER_EMAIL },
      ]}
      intro={
        <>
          Esta Aplicação utiliza apenas Rastreadores próprios e estritamente
          necessários ao seu funcionamento, pelo que não apresenta pedido de
          consentimento de cookies. Para saber que Dados Pessoais tratamos e com
          que finalidade, consulte a{' '}
          <Link
            to="/privacidade"
            className="font-semibold text-white underline underline-offset-4"
          >
            Política de Privacidade
          </Link>
          .
        </>
      }
      sections={cookiePolicySections}
    />
  );
}
